import script from "./HomeworkCompletionDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeworkCompletionDashboard.vue?vue&type=script&setup=true&lang=js"

import "./HomeworkCompletionDashboard.vue?vue&type=style&index=0&id=39822bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39822bb8"]])

export default __exports__